export const People = [
  { id: 'minju', name: 'Minju Yoo', affiliation: 'KAIST', url: 'https://minjuu1.github.io/' },
  { id: 'juho', name: 'Juho Kim', affiliation: 'KAIST', url: 'https://juhokim.com/' },
  { id: 'joseph', name: 'Joseph Seering', affiliation: 'KAIST', url: 'https://joseph.seering.org/' },
  { id: 'hyoungwook', name: 'Hyoungwook Jin', affiliation: 'University of Michigan', url: 'https://jhw123.github.io/' },
  { id: 'jeongeon', name: 'Jeongeon Park', affiliation: 'UCSD', url: 'https://jeongeonpark.com/' },
  { id: 'xu', name: 'Xu Wang', affiliation: 'University of Michigan', url: 'https://web.eecs.umich.edu/~xwanghci/' },
  { id: 'tomo', name: 'Tomohiro Nagashima', affiliation: 'Saarland University', url: 'https://tomonag.org/' },
  { id: 'mirella', name: 'Mirella Hladký', affiliation: 'Saarland University' },
  { id: 'grace', name: 'Eunhye Kim', affiliation: 'KAIST', url: 'https://gracekim.me/' },
  { id: 'sadat', name: 'Sadat Shams Chowdhury', affiliation: 'KAIST' },
  { id: 'jinwook', name: 'Jinwook Seo', affiliation: 'SNU' },
  { id: 'kiroong', name: 'Kiroong Choe', affiliation: 'SNU' },
  { id: 'jieun', name: 'Jieun Han', affiliation: 'KAIST', url: 'https://zeunie.github.io/' },
  { id: 'soyeon', name: 'So-yeon Ahn', affiliation: 'KAIST', url:'https://sites.google.com/view/soyeonahn/about'},
  { id: 'zixin', name: 'Zixin Chen', affiliation: 'HKUST', url: 'https://cinderd.github.io/' },
  { id: 'daeun', name: 'DaEun Choi', affiliation: 'KAIST' },
  { id: 'jenny', name: 'Jenny C. Yang', affiliation: 'KAIST' },
];